import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",

    "@media (max-width: 550px)": {
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
  },
  descripptTxt: {
    fontSize: 14,
    fontWeight: 500,
  },
  logo: {
    width: "160px",
    height: "auto",
    paddingBottom: "15px",
    objectFit: "contain",

    "@media (max-width: 550px)": {
      margin: "0 auto",
    },
  },
}));

type Props = {
  accountNumber: string;
  addr: string;
  debtInfoDate?: string;
  regionName: string;
};

const PaymentHeader = ({
  accountNumber,
  addr,
  debtInfoDate,
  regionName,
}: Props) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.header}>
        <div
          style={{
            maxWidth: "300px",
          }}
        >
          <div className={classes.descripptTxt}>
            <p>Лицевой счет: {accountNumber}</p>
            <p style={{ marginTop: "-7px", marginBottom: "18px" }}>
              Адрес: {addr}
            </p>
            <p style={{ marginTop: "-10px", marginBottom: "8px" }}>
              Информация актуальна на{" "}
              {debtInfoDate
                ? new Date(debtInfoDate).toLocaleDateString("ru-RU")
                : "неизвестно"}
            </p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: "15px",
          }}
        >
          <img
            src={regionName}
            alt="Логотип"
            className={classes.logo}
            style={{
              width: regionName.includes("vostok") ? "110px" : undefined,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentHeader;
